import React from 'react'
import {
    List,
    Datagrid,
    TextField,
    DateField,
    NumberField,
} from 'react-admin'


export const DecretoList = props => (
    <List {...props} exporter={false} >
        <Datagrid rowClick="show">
            <NumberField source="id" />
            <TextField source="name" />
            <TextField source="description" />
            <TextField source="date" />
        </Datagrid>
    </List>
);
